import {
  uploadAttachment,
  threadAttachmentPath,
  activityAttachmentPath,
  documentUploadPath,
  documentToAttachment,
} from '@coparent/shared/src/services/attachmentService';
import { createDocumentRecord } from '@coparent/shared/src/services/documentService';

/**
 * Upload a browser File as a message/activity attachment and return the stored
 * metadata. When saveToDocs is true the file is also filed into the Documents
 * vault (single upload) and the returned metadata carries a documentId.
 *
 * @param {string} familyId
 * @param {File} file - browser File (has .name/.type/.size)
 * @param {{ scope:'thread'|'activity', parentId:string, saveToDocs?:boolean, category?:string, childIds?:string[], currentUser:object, onProgress?:(pct:number)=>void }} opts
 */
export async function uploadFileAttachment(familyId, file, opts) {
  const { scope, parentId, saveToDocs, category, childIds, currentUser, onProgress } = opts;
  const meta = { fileName: file.name, fileType: file.type, fileSize: file.size, onProgress };

  if (saveToDocs) {
    const storagePath = documentUploadPath(familyId, file.name);
    const { url } = await uploadAttachment(storagePath, file, meta);
    const document = await createDocumentRecord(familyId, {
      name: file.name,
      category: category || 'other',
      childIds: childIds || [],
      uploadedBy: currentUser.uid,
      uploadedByName: currentUser.displayName || 'Unknown',
      storageUrl: url,
      storagePath,
      fileType: file.type,
      fileSize: file.size,
      originalFileName: file.name,
    });
    return documentToAttachment(document);
  }

  const storagePath = scope === 'activity'
    ? activityAttachmentPath(familyId, parentId, file.name)
    : threadAttachmentPath(familyId, parentId, file.name);
  return uploadAttachment(storagePath, file, meta);
}
